export default "/static/assets/1bae366493daf4c4.png"